import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

export default function getHistorics(filters) {
  const config = {
    method: "GET",
    url: buildRequestUrl(filters, "historical_data"),
  };

  return athenaClient(config);
}

export const getPointsOfSales = (byDate = false, filters) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(
      filters,
      byDate ? "points_of_sale_by_date" : "points_of_sale"
    ),
  };

  return athenaClient(config);
};
